import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PageShell, PageHero } from "../components/PageShell";
import { Reveal } from "../components/Reveal";
import { engagements } from "../data/content";

export default function Outsourcing() {
  return (
    <PageShell>
      <div data-testid="outsourcing-page">
        <PageHero
          overline="Outsourcing"
          title="Your Technology Team, Extended."
          description="Great products don't always require a large in-house engineering organization. Spark Link provides flexible software development and technology partnerships for businesses that need additional engineering capability, specialized expertise, or complete project delivery."
        />

        <section className="py-20 lg:py-28">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid gap-4 md:grid-cols-2">
              {engagements.map((engagement, i) => (
                <Reveal key={engagement.title} delay={0.07 * i} className="h-full">
                  <Link
                    to={`/outsourcing/${engagement.slug}`}
                    className="card-gradient group flex h-full flex-col rounded-xl border border-white/[0.08] p-8 lg:p-10 transition-colors duration-300 hover:border-cyan-400/40"
                    data-testid={`engagement-card-${i}`}
                  >
                    <div className="flex items-center justify-between">
                      <span className="text-outline font-display text-5xl font-extrabold leading-none transition-all duration-500 group-hover:[-webkit-text-stroke:1px_rgba(0,240,255,0.55)]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="spark-gradient h-px w-12 opacity-60" />
                    </div>
                    <h2 className="mt-7 font-display text-xl sm:text-2xl font-semibold tracking-tight text-white">
                      {engagement.title}
                    </h2>
                    <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-cyan-400">
                      {engagement.ask}
                    </p>
                    <p className="mt-3 flex-1 text-sm sm:text-base leading-relaxed text-slate-400">
                      {engagement.desc}
                    </p>
                  </Link>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.2}>
              <div className="mt-16 flex flex-col items-start justify-between gap-8 rounded-2xl border border-white/10 bg-white/[0.02] p-8 lg:flex-row lg:items-center lg:p-12">
                <p className="max-w-xl font-display text-xl sm:text-2xl font-medium leading-snug text-white">
                  "Tell us what you are building. We'll help you determine the right way to build
                  it."
                </p>
                <Link
                  to="/contact"
                  data-testid="outsourcing-cta-btn"
                  className="spark-gradient group inline-flex shrink-0 items-center gap-2 rounded-full px-7 py-3.5 font-display text-sm font-semibold text-white transition-transform duration-300 hover:scale-[1.03]"
                >
                  Start a Conversation
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </Reveal>
          </div>
        </section>
      </div>
    </PageShell>
  );
}
